import React from 'react';
import { Eyebrow } from './ui/Eyebrow';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  const [featured, ...rest] = testimonials;
  return <section className="border-b border-line bg-sand" data-id="element-243" data-mp="1n0addghtiqw3">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-244" data-mp="1mzsaw24kbgfq">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between" data-id="element-245" data-mp="1r0ubone4o0jt">
          <div data-id="element-246" data-mp="1d1be2oiy07lr">
            <Eyebrow data-id="element-247" data-mp="1d0t9n4m4mn2r">La eligen profes de guitarra</Eyebrow>
            <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-248" data-mp="1i0xuf6u2i3ys">
              Lo que dicen los profes
            </h2>
          </div>
          <p className="text-[13px] text-ink-mute" data-id="element-249" data-mp="14399y03wwyu9">
            Estudios, academias y profesores particulares
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-250" data-mp="2yeo0gj4qz2b2">
          <figure className="flex h-full flex-col overflow-hidden rounded-2xl border border-line bg-paper shadow-card" data-id="element-251" data-mp="2yd33ynyvh9ak">
            {featured.photo && <img src={featured.photo} alt={`${featured.name}, ${featured.role}`} className="h-64 w-full object-cover object-top sm:h-72" loading="lazy" data-id="element-252" data-mp="2v0syjk18mo8n" />}
            <div className="flex flex-1 flex-col p-8 sm:p-10" data-id="element-253" data-mp="34tgnxtpw1pxc">
              <blockquote className="font-display text-2xl italic leading-snug text-ink sm:text-[26px]" data-id="element-254" data-mp="2ztm0k05bnih1">
                “{featured.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-8" data-id="element-255" data-mp="2745ava936foi">
                <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-ink text-sm font-semibold text-cream" data-id="element-256" data-mp="275zu8k4plzqh">
                  {featured.initials}
                </span>
                <span data-id="element-257" data-mp="18u8eexfz51i">
                  <span className="block text-sm font-semibold text-ink" data-id="element-258" data-mp="1ci3vjmg61iv">{featured.name}</span>
                  <span className="block text-[13px] text-ink-mute" data-id="element-259" data-mp="3sjb16ce4dgi4">{featured.role}</span>
                </span>
              </figcaption>
            </div>
          </figure>

          <ul className="grid gap-4" data-id="element-260" data-mp="8cal33goield">
            {rest.map(item => <li key={item.name} className="flex flex-col rounded-xl border border-line bg-paper px-6 py-5" data-id="element-261" data-mp="ddzwwlbq6wai">
                <blockquote className="text-[15px] leading-relaxed text-ink-soft" data-id="element-262" data-mp="3gtouz4ll92yp">
                  “{item.quote}”
                </blockquote>
                <div className="mt-auto flex items-center gap-3 pt-4" data-id="element-263" data-mp="3ltt8qmv43jl8">
                  {item.photo ? <img src={item.photo} alt={`${item.name}, ${item.role}`} className="h-10 w-10 shrink-0 rounded-full object-cover object-top" loading="lazy" data-id="element-264" data-mp="3qr30wa9vy9cr" /> : <span aria-hidden="true" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sand text-[11px] font-semibold text-ink-soft" data-id="element-265" data-mp="330z6mtil7lyf">
                      {item.initials}
                    </span>}
                  <span className="text-[13px] text-ink" data-id="element-266" data-mp="1b4ms6m0ykvek">
                    <span className="font-semibold" data-id="element-267" data-mp="16861pl6ae4yb">{item.name}</span>
                    <span className="text-ink-mute" data-id="element-268" data-mp="1189znrh5gnle"> · {item.role}</span>
                  </span>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}